import type { Timeline } from '../scenarios/index.ts';

const pad = (n: number, w = 2) => String(Math.floor(n)).padStart(w, '0');

const WEEK_S = 604800;

/** Scenario time as the timeline's unit wants it read; `origin` is what t = 0 reads as in that unit (the fetal atlas's 21 weeks). */
export function formatTime(t: number, unit: Timeline['unit'], origin = 0): string {
  switch (unit) {
    case 'week':
      return `${(origin + t / WEEK_S).toFixed(1)} wk`;
    case 'ms':
      return `${Math.round(t * 1000)} ms`;
    case 's': {
      const m = Math.floor(t / 60);
      return m ? `${m}:${pad(t % 60)}.${Math.floor((t * 10) % 10)}` : `${(t % 60).toFixed(1)} s`;
    }
    case 'min':
      return `${pad(t / 60)}:${pad(t % 60)}`;
    case 'h': {
      const h = Math.floor(t / 3600);
      const m = Math.floor((t % 3600) / 60);
      return `${h}:${pad(m)} h`;
    }
  }
}

export function formatSpeed(speed: number): string {
  if (speed < 60) return `${speed < 1 ? speed.toString().replace(/^0/, '') : speed}×`;
  if (speed < 3600) return `${speed / 60} min/s`;
  if (speed < 86400) return `${speed / 3600} h/s`;
  return `${+(speed / WEEK_S).toFixed(2)} wk/s`;
}
